__turbopack_context__.v({
  "uploadBox": "UploadBox-module__OidwcW__uploadBox",
  "uploadBoxDisabled": "UploadBox-module__OidwcW__uploadBoxDisabled",
  "uploadBoxLoading": "UploadBox-module__OidwcW__uploadBoxLoading",
  "uploadBoxOnSubtleBackground": "UploadBox-module__OidwcW__uploadBoxOnSubtleBackground",
});
